import type { QueryClient } from 'react-query';
import { queryKeys } from 'RestAPIs/rapini';

// The grid and the tab badges are two separate queries over the same tasks, so
// anything that changes a task has to refresh both or they drift apart.
export const invalidatePlannerTasks = (queryClient: QueryClient) => {
  queryClient.invalidateQueries('plannerTasks');
  // First element of the generated key array, not `.name` on the key factory:
  // that resolves through JS's inferred-name rules, and if codegen ever changes
  // shape it silently becomes undefined — which react-query v3 reads as "match
  // every query" and turns this into a full-cache refetch.
  queryClient.invalidateQueries(queryKeys.getTaskDefinitionsCount('', '')[0]);
};
